import React, { useContext, useEffect, useRef } from "react";
import { AppCtx } from "../../../AppCtx";
import './TopFloatMenuComponent.css';

const menuStyle = {
  position:'fixed', zIndex:11, top:0, left:0, width:'36px', height:'36px',
  padding:0, boxSizing:'border-box', borderRadius:'6px', fontSize:'1.3em', gap:'0px',
  color:'var(--float-menu-font-color)',
  backgroundColor:'var(--float-menu-bg-color)',
  display:'flex', alignItems:'center', justifyContent:'center'
};

// Convert back to a const arrow function
const TopLeftMenuComponent = ({ children }) => {
  const { showQuickMenu, isFullScreen } = useContext(AppCtx);
  return (showQuickMenu || !isFullScreen) && ( <div className="top-bar-edge top-bar-left" style={menuStyle} >{children}</div>);
};

export default TopLeftMenuComponent;
